import React, { Component } from 'react'
import InputGroup from '../inputs/InputGroup'
import classnames from 'classnames'
import AsyncCreatable  from 'react-select/lib/AsyncCreatable'
import defaultSelectTheme from './styles/defaultSelectTheme'

import SVG from 'react-inlinesvg'
import refreshIcon from '@icons/refresh/black'

const themeProps = {
  default: defaultSelectTheme
}

class AsyncCreatableSelect extends Component {
  constructor(props) {
    super(props)
    this.renderComponent = this.renderComponent.bind(this)
  }

  renderComponent({ components, ...forwardedProps}) {
    const { theme } = this.props
    const prefix = 'react-select';
    const selectClasses = classnames(prefix, `${prefix}--${theme}`);

    return (
      <AsyncCreatable
        placeholder={ I18n.t('helpers.select.prompt') }
        className={selectClasses}
        classNamePrefix={prefix}
        styles={themeProps[theme]}
        loadingPlaceholder={ I18n.t('teacher_students.form.processing') }
        noOptionsMessage={ () => I18n.t('teacher_students.form.no_options') }
        loadingMessage={ () => I18n.t('teacher_students.form.processing') }
        components={
          { ...components,
            ClearIndicator: ({clearValue, getValue}) => {
              const value = getValue()
              if (value && value[0] && value[0].__isNew__) {
                return (
                  <a href="javascript:void(0)" onClick={(e) => clearValue()}>
                    <SVG src={refreshIcon} />
                  </a>
                )
              }

              return null
            }
          }
        }
        {...forwardedProps}
      />
    )
  }

  render() {
    const { theme, ...props } = this.props
    return ( <InputGroup {...props} Component={this.renderComponent} /> );
  }
};

AsyncCreatableSelect.defaultProps = {
  theme: "default"
}

export default AsyncCreatableSelect
